import {
  BorderRadiusCorners,
  BorderStyle,
  BordersStyles,
  Box,
  Icon,
  ScrollContainer,
  Tag,
  Text,
} from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { HiringStage } from 'modules/ats/hooks/hiringStages/useHiringStages'
import { getProperties, isHired, isNew } from 'modules/ats/lib/utils/hiringStages'

interface Props {
  stages: HiringStage[]
}

export const StageCards = ({ stages }: Props) => {
  const borderRadius = (stage: HiringStage): BorderRadiusCorners => {
    if (isNew(stage.name)) return { bottomLeft: 'abs006' }
    if (isHired(stage.name)) return { bottomRight: 'abs006' }

    return {}
  }

  const border = (stage: HiringStage): BordersStyles => {
    const defaultBorderProperties: BorderStyle = { color: 'grey400', style: 'solid', width: 's1' }

    return {
      left: isNew(stage.name)
        ? defaultBorderProperties
        : { ...defaultBorderProperties, style: 'hidden' },
      right: defaultBorderProperties,
      bottom: defaultBorderProperties,
      top: {
        color: getProperties(stage.name).color,
        style: 'solid',
        width: 's4',
      },
    }
  }

  return (
    <ScrollContainer minWidth="100%">
      <Box width="full" flexDirection="row">
        {stages.map((stage) => (
          <Box
            key={`${stage.id}-${stage.position}`}
            width="full"
            minWidth="s140"
            height="s120"
            flexDirection="row"
            alignItems="center"
            justifyContent="center"
            borderRadius={borderRadius(stage)}
            border={border(stage)}
          >
            <Box flexDirection="column" alignItems="center" gap="s8" paddingY="s16">
              <Icon.Medium icon={getProperties(stage.name).icon} color="grey800" />
              <Text.Normal weight="normal" color="grey800">
                {stage.label}
              </Text.Normal>
              {!isNew(stage.name) && !isHired(stage.name) && (
                <Tag type={getProperties(stage.name).tagColor}>
                  {i18n.tp('ats.hiring_pipelines.settings.phases_number', {
                    count: stage.hiringPhases.length,
                  })}
                </Tag>
              )}
            </Box>
          </Box>
        ))}
      </Box>
    </ScrollContainer>
  )
}
